import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _isEmpty from "lodash/isEmpty";
var _excluded = ["fields", "className", "onSubmit", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { validateFields } from '../../validation/validationUtil';
var FinalForm = function FinalForm(props) {
  var fields = props.fields,
    className = props.className,
    onSubmit = props.onSubmit,
    children = props.children,
    finalFormProps = _objectWithoutProperties(props, _excluded);
  var onSubmitFn = useCallback(function (values) {
    // Revalidate fields before a submission, and return the errors as submission errors.
    // This is needed because some fields require a submission before the error message is displayed
    var errors = validateFields(fields)(values);
    if (!_isEmpty(errors)) return errors;
    return onSubmit(values);
  }, [onSubmit]);
  return /*#__PURE__*/React.createElement(Form, _extends({
    onSubmit: onSubmitFn
  }, finalFormProps), function (formRenderProps) {
    var handleSubmit = formRenderProps.handleSubmit,
      submitting = formRenderProps.submitting,
      submitErrors = formRenderProps.submitErrors,
      errors = formRenderProps.errors,
      modifiedSinceLastSubmit = formRenderProps.modifiedSinceLastSubmit,
      name = formRenderProps.name;

    // `display` contains form information that has been processed for form display purposes
    var display = {
      // Prioritise on showing submission errors if it exist and
      // the form has not been modified after last submit
      errors: submitErrors && !modifiedSinceLastSubmit ? submitErrors : errors
    };
    return /*#__PURE__*/React.createElement("form", {
      className: classNames('Form', className, {
        submitting: submitting
      }),
      onSubmit: handleSubmit,
      noValidate: true,
      name: name
    }, children(_objectSpread(_objectSpread({}, formRenderProps), {}, {
      display: display
    })));
  });
};
FinalForm.propTypes = {
  fields: PropTypes.array,
  initialValues: PropTypes.object,
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  children: PropTypes.func,
  name: PropTypes.string
};
export default FinalForm;